import { isUndefined } from 'lodash';

import TemporaryHoldBadge from './temporary-hold-badge';
import s from '../../styles.module.scss';
import HoldingStatusBadge from './holding-status-badge';
import ConsumableBadge from './consumable-badge';
import PmpmStatusBadge from './pmpm-status-badge';

import type { IPatientHoldingStatus } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface BadgesProps {
  showTemporaryHoldBadge?: boolean;
  showHoldingStatusBadge: boolean;
  holdingStatus?: IPatientHoldingStatus;
  remainingDays: number;
  showConsumablesBadge?: boolean;
  consumablesRemainingDays?: number;
  showPmpmBadge?: boolean;
}

const Badges: FC<BadgesProps> = ({
  holdingStatus,
  remainingDays,
  showHoldingStatusBadge,
  consumablesRemainingDays,
  showConsumablesBadge,
  showTemporaryHoldBadge,
  showPmpmBadge,
}) => {
  return (
    <div className={s.badges}>
      {showTemporaryHoldBadge && <TemporaryHoldBadge />}
      {showHoldingStatusBadge && !isUndefined(holdingStatus) && (
        <HoldingStatusBadge
          holdingStatus={holdingStatus}
          remainingDays={remainingDays}
        />
      )}
      {showConsumablesBadge && !isUndefined(consumablesRemainingDays) && (
        <ConsumableBadge consumablesRemainingDays={consumablesRemainingDays} />
      )}
      {showPmpmBadge && <PmpmStatusBadge />}
    </div>
  );
};
export default Badges;
